import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { AccountTaxStatusDTO } from '../../../../../../api/useAccountsQuery';
import { useAccountTaxStatusLabel } from '../../hooks/useAccountTaxStatusLabel';
import { AccountType } from '../../../../../../api/useAccountsOptionsQuery';

interface Props {
  formKey?: string;
  taxStatus?: AccountTaxStatusDTO | null;
}

export const AccountEarmark = ({
  formKey = 'bankAccount.AccountEarmark',
  taxStatus = null,
}: Props) => {
  const {
    options: { EarmarkOptions, EducationEarmarkOptions },
  } = useAccountFormContext();

  const { watch, control } = useFormContext();

  const accountType = watch('bankAccount.AccountType');

  const options = accountType === AccountType.E529 ? EducationEarmarkOptions : EarmarkOptions;

  const allGoalsOption = EarmarkOptions.filter(goal => goal.value === 'AllGoals');

  const { taxStatusLabel } = useAccountTaxStatusLabel(taxStatus);

  return (
    <Controller
      control={control}
      name={formKey}
      render={({ field: { value, onChange } }) => {
        const isAllGoalsSelected = value.find(goal => goal.value === 'AllGoals');

        return (
          <Select
            isMulti
            isPortal
            options={isAllGoalsSelected ? allGoalsOption : options}
            value={value}
            onChange={earmarks => onChange(earmarks)}
            label={
              taxStatusLabel === null ? 'Account Earmark' : `${taxStatusLabel} Account Earmark`
            }
            tooltip="Please select the goal(s) you will fund with this specific account."
            closeMenuOnSelect={false}
          />
        );
      }}
    />
  );
};
